import { render, staticRenderFns } from "./InstabankCardContainer.vue?vue&type=template&id=c4d62344&"
import script from "./InstabankCardContainer.vue?vue&type=script&lang=js&"
export * from "./InstabankCardContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports